import { AxiosResponse } from 'axios';
import { createClient } from 'services/clientConfiguration';
import * as LaunchpadTypes from 'types/Launchpad';

const BASE_URL = '/rest-api/launchpad-service/v1';
const V2_BASE_URL = '/rest-api/launchpad-service/v2';

const http = createClient({
  baseURL: BASE_URL,
});

const v2Http = createClient({
  baseURL: V2_BASE_URL,
});

export const getAccountInfoCounters = (
  sso: string,
  corpAcctNbr: number,
): Promise<AxiosResponse<LaunchpadTypes.AccountInfoCounters>> => {
  const url = `/accountInfoCounters`;

  return http.get(url, {
    headers: {
      'nextiva-context-corpAcctNumber': corpAcctNbr,
      Authorization: `Bearer ${sso}`,
    },
  });
};

export const getAccountInfoCountersV2 = (
  sso: string,
  corpAcctNbr: number,
): Promise<AxiosResponse<LaunchpadTypes.AccountInfoCounters>> => {
  const url = `/corpAccountNumber/${corpAcctNbr}/accountInfoCounters`;

  return v2Http.get(url, {
    headers: {
      'nextiva-context-corpAcctNumber': corpAcctNbr,
      Authorization: `Bearer ${sso}`,
    },
  });
};

export const getIsVoiceAccount = (
  sso: string,
  corpAcctNbr: number,
): Promise<AxiosResponse<boolean>> => {
  const url = `/isVoiceAccount`;
  return http.get(url, {
    headers: {
      'nextiva-context-corpAcctNumber': corpAcctNbr,
      Authorization: `Bearer ${sso}`,
    },
  });
};
